export const EMPTY_SPACE = '\u00A0';
